import React from 'react';

const Facebook = () => (
	<svg viewBox="0 0 44 44" className="icon faceboo">
<path d="M19.49,32V20.43H17.6V18.57h1.89v-.64A6.33,6.33,0,0,1,21,13.25,4.67,4.67,0,0,1,24.32,12a5.66,5.66,0,0,1,2.08.39l-.33,1.89A3.65,3.65,0,0,0,24.51,14c-2.08,0-2.61,1.83-2.61,3.88v.72h3.25v1.86H21.9V32Z" fill="#009fe3" stroke="#009fe3" strokeMiterlimit="10" />
  </svg>
);

export default Facebook;
